import { createClient } from '@supabase/supabase-js';

import { clientEnvironment } from '../config/client-env';

export const hasSupabaseClient = Boolean(
  clientEnvironment.VITE_SUPABASE_URL && clientEnvironment.VITE_SUPABASE_PUBLISHABLE_KEY,
);

export const supabase = hasSupabaseClient
  ? createClient(
      clientEnvironment.VITE_SUPABASE_URL as string,
      clientEnvironment.VITE_SUPABASE_PUBLISHABLE_KEY as string,
    )
  : null;
